module.exports = __webpack_public_path__ + "static/img/babe.382ec6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/babe.svg
// module id = zMHy
// module chunks = 2